import { c as _c } from "react/compiler-runtime";
import ErrorBoundary from '@sbt-web/error-boundary';
import type { Faq, FaqItem } from '@sbt-web/network/types';
import { getSafeHTML } from '@sbt-web/utils';
import { ToggleDetails } from '../ToggleDetails';
import { AiDisclaimer } from './components/AiDisclaimer';
import { FAQStructuredData } from './components/FAQStructuredData';
import { trackEvent } from './utils/trackEvent';
import classes from './index.module.scss';
interface FaqProps {
  data: Faq | null;
}
function renderText(text: string) {
  return getSafeHTML(text, {
    ALLOWED_TAGS: ['b']
  });
}
function FaqComponent(t0) {
  const $ = _c(16);
  const {
    data
  } = t0;
  const handleToggle = _temp;
  if (!data?.faq?.length) {
    return null;
  }
  let t1;
  if ($[0] !== data) {
    t1 = <FAQStructuredData data={data} />;
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className={classes.heading}><h2>Domande frequenti sulla tua ricerca</h2><AiDisclaimer /></header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.intro) {
    t3 = renderText(data.intro);
    $[3] = data.intro;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className={classes.intro}>{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== data.faq) {
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = (faqData, index) => <ToggleDetails key={`${index}-${faqData.question}`} summary={<h3 itemProp="name">{faqData.question}</h3>} onDetailsToggle={handleToggle} detailsTestId="faq-details" summaryTestId="faq-summary" className={classes.question}><div data-testid="faq-answer"><p>{renderText(faqData.answer)}</p></div></ToggleDetails>;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = data.faq.map(t6);
    $[7] = data.faq;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <div className={classes.questions}>{t5}</div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t4 || $[14] !== t6) {
    t7 = <section className={classes.container} data-google-interstitial="false">{t1}{t2}{t4}{t6}</section>;
    $[12] = t1;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp(isOpen) {
  return trackEvent(isOpen);
}
export default function Faq(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ErrorBoundary><FaqComponent {...props} /></ErrorBoundary>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}